<template>
  <div class="circle__container">
    <div
      class="circle-half"
      :style="{ width: `${circleSize / 2}px`, height: `${circleSize}px` }"
    >
      <div
        :class="`circle background-${leftColor}`"
        :style="{
          borderRadius: `${leftSize / 2}px`,
          width: `${leftSize}px`,
          height: `${leftSize}px`,
          right: `-${leftSize / 2}px`,
          top: `${circleSize / 2 - leftSize / 2}px`,
        }"
      />
      <div class="circle__label" v-if="!hideLeftAmount">
        <span
          :class="{ 'f-ui-1': circleSize > 100, 'f-ui-2': circleSize <= 100 }"
          >{{ left }} {{ units }}</span
        >
      </div>
    </div>
    <div
      class="circle-half"
      :style="{ width: `${circleSize / 2}px`, height: `${circleSize}px` }"
    >
      <div
        :class="`circle background-${rightColor}`"
        :style="{
          borderRadius: `${rightSize / 2}px`,
          width: `${rightSize}px`,
          height: `${rightSize}px`,
          left: `-${rightSize / 2}px`,
          top: `${circleSize / 2 - rightSize / 2}px`,
        }"
      />
      <div class="circle__label">
        <span
          :class="{ 'f-ui-1': circleSize > 100, 'f-ui-2': circleSize <= 100 }"
          >{{ right }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    circleSize: {
      type: Number,
      default: 150,
    },
    left: {
      type: Number,
      required: true,
    },
    right: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    units: {
      type: String,
      default: "",
    },
    leftColor: {
      type: String,
      default: "historic",
    },
    rightColor: {
      type: String,
      default: "STEPS",
    },
    hideLeftAmount: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maxSize() {
      return this.radiusToArea(this.circleSize);
    },
    leftSize() {
      return this.areaToRadius(this.maxSize * (this.left / this.max));
    },
    rightSize() {
      return this.areaToRadius(this.maxSize * (this.right / this.max));
    },
  },
  methods: {
    radiusToArea(radius) {
      return Math.PI * radius * radius;
    },
    areaToRadius(area) {
      return Math.sqrt(area / Math.PI);
    },
  },
};
</script>

<style scoped>
@import url("../css/colors.css");
.circle__container {
  position: relative;
  display: flex;
}
.circle-half {
  position: relative;
  overflow: hidden;
  display: flex;
}
.circle-half:first-of-type {
  border-right: 1px solid black;
}
.circle {
  position: absolute;
  transition: all 0.5s ease;
}
.circle__label {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 729px) {
  .circle__label span.f-ui-2 {
    font-size: 12px !important;
    line-height: 12px !important;
  }
}
</style>